import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSparkle2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sparkle-2, star, magic, ai"><g clipPath="url(#clip0_6188_50731)"><path d="M3.25 12C7.5 10.5 10.5 7.5 12 3.25C13.5 7.5 16.5 10.5 20.75 12C16.5 13.5 13.5 16.5 12 20.75C10.5 16.5 7.5 13.5 3.25 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></g><defs><clipPath id="clip0_6188_50731"><rect width="24" height="24" fill="white"/></clipPath></defs></CentralIconBase>;
};

export default IconSparkle2;
